$(document).ready(function() {
  $(document).on('click','.inquire-form-btn button',function(e) {
    e.preventDefault();
    $('.inquire-form-popup').addClass('show-popup');
    var get_product_title = $('form.inquire-btn input.product-name').val();
    console.log('Inquiry about = '+get_product_title);
    // $('.inquire-form-popup .popup-left-area .klaviyo-form form').append('<input type="hidden" name="product_title" value="'+get_product_title+'" />');
    // setInterval(function() {
    // $('.inquire-form-popup .popup-left-area .klaviyo-form form>div>div:nth-child(10) input').val(get_product_title);
    // },100);
  }); 
  
  $(document).on('click','.inquire-form-popup .close-popup',function(e) {
    e.preventDefault();
    $('.inquire-form-popup').removeClass('show-popup');
  });

  var default_variant = $('.toorder-btn-area.false-area input[name="id"]').val();
  var get_metafield = $('.default_select option[value="'+default_variant+'"]').data('order-metafield');
  console.log('default_variant = '+default_variant);
  console.log('get_metafield = '+get_metafield);
        if(default_variant == "" || default_variant == undefined){
         var get_metafield = $('.default_variant_metafield').val();
      }
    if(get_metafield == true ||get_metafield == "true" ) {
      // $('.toorder-btn-area.true-area').addClass('show-button');
      // $('.toorder-btn-area.false-area').removeClass('show-button');
      $('.toorder-btn-area.false-area form buy-buttons button.gPreorderBtn').remove();
      $('.toorder-btn-area.false-area form .addtocartbtn.button.w-full').hide();
      $('.toorder-btn-area.false-area form buy-buttons').append('<button type="submit" class="button button--outline w-full gPreorderBtn">Make To Order</button>');
      $('.toorder-btn-area.false-area form').append('<input type="hidden" class="gPreorderProperty" name="properties[_is_preorder]" value="Note: Made To Order Product">');
      $('.toorder-btn-area.false-area form .addtocartbtn').addClass('hide-button');
      $('.toorder-btn-area.false-area form .addtocartbtn').removeClass('show-button');
    }
  else {
    $('.toorder-btn-area.false-area form .button.gPreorderBtn').hide();
    $('.toorder-btn-area.false-area form .addtocartbtn.button.w-full').show();
    $('.toorder-btn-area.false-area form .gPreorderProperty').remove();
    // $('.toorder-btn-area.true-area').removeClass('show-button');
      // $('.toorder-btn-area.false-area').addClass('show-button');
    // $('.toorder-btn-area.false-area form buy-buttons').append('<button type="submit" class="button button--outline w-full">Add To Cart</button>');
    $('.toorder-btn-area.false-area form .addtocartbtn').removeClass('hide-button');
    $('.toorder-btn-area.false-area form .addtocartbtn').addClass('show-button');
  }
  $(document).on('click','.variant-picker__option-values input',function() {
    setTimeout(function() {
    var changed_variant = $('.toorder-btn-area.false-area input[name="id"]').val();
  var changed_get_metafield = $('.default_select option[value="'+changed_variant+'"]').data('order-metafield');
      console.log('changed_variant = '+changed_variant);
      console.log('changed_get_metafield = '+changed_get_metafield);
      if(changed_variant == ""){
         var changed_get_metafield = $('.default_variant_metafield').val();
      }
    if(changed_get_metafield == true ||changed_get_metafield == "true" ) {
      // $('.toorder-btn-area.true-area').addClass('show-button');
      // $('.toorder-btn-area.false-area').removeClass('show-button');
      $('.toorder-btn-area.false-area form buy-buttons button.gPreorderBtn').remove();
      $('.toorder-btn-area.false-area form .addtocartbtn.button.w-full').hide();
      $('.toorder-btn-area.false-area form buy-buttons').append('<button type="submit" class="button button--outline w-full gPreorderBtn">Make To Order</button>');
      $('.toorder-btn-area.false-area form').append('<input type="hidden" class="gPreorderProperty" name="properties[_is_preorder]" value="Note: Made To Order Product">');
      $('.toorder-btn-area.false-area form .addtocartbtn').addClass('hide-button');
      $('.toorder-btn-area.false-area form .addtocartbtn').removeClass('show-button');
    }
  else {
    $('.toorder-btn-area.false-area form .button.gPreorderBtn').hide();
    $('.toorder-btn-area.false-area form .addtocartbtn.button.w-full').show();
    $('.toorder-btn-area.false-area form .gPreorderProperty').remove();
    // $('.toorder-btn-area.true-area').removeClass('show-button');
      // $('.toorder-btn-area.false-area').addClass('show-button');
    // $('.toorder-btn-area.false-area form buy-buttons').append('<button type="submit" class="button button--outline w-full">Add To Cart</button>');
    $('.toorder-btn-area.false-area form .addtocartbtn').removeClass('hide-button');
    $('.toorder-btn-area.false-area form .addtocartbtn').addClass('show-button');
  }
      },500);
  });
});

